/**************************************************
 * Nombre:       TablaHistorial
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {useEffect, useState} from "react";
import useRecuperarColleccionListeningProg from "../../Servicios/BD/useRecuperarColleccionListeningProg";
import {where} from "firebase/firestore";
import TarjetaHistorial from "./TarjetaHistorial";

const TablaHistorial = ({coleccion, propiedadId, id = 'none'}) => {
    const [wheres, setWheres] = useState([where(propiedadId, '==', id)]);
    const {data, cargarMas, mas} = useRecuperarColleccionListeningProg({col: coleccion, wheres: wheres, numero: 10})
    const [open, setOpen] = useState(false);


    useEffect(() => {

        console.log(data)

    },[data])
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{borderTop: 1, pt: 2, mt: 2}}
            >

                <Grid container size={6} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{fontWeight: 600}}>Historial</Typography>
                </Grid>

                <Grid container size={6} sx={{justifyContent: 'flex-end'}}>
                    <Button
                        variant={'outlined'}
                        onClick={() => setOpen(!open)}
                    >Ver Historial</Button>
                </Grid>

                {open &&
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}>

                        {data.length <= 0 ?
                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                <Typography sx={{fontSize: 12}}>No hay Historial</Typography>
                            </Grid>

                            :

                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}
                                sx={{mt: 2}}
                            >

                                {data.map((item, i) => {
                                    return (
                                        <TarjetaHistorial item={item} index={i}/>
                                    )
                                })}

                            </Grid>


                        }


                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                            {mas &&
                                <Button
                                    onClick={() => cargarMas()}
                                    variant={'text'}>Cargar Mas</Button>
                            }
                        </Grid>

                    </Grid>
                }


            </Grid>

        </Grid>
    )

}
export default TablaHistorial